import { isConnectad, safeKey } from "./config";
import { bump } from "./sink";

export function installEventFunnel(): void {
  const w = window as any;
  if (!w.pbjs) w.pbjs = { que: [] };
  else if (!Array.isArray(w.pbjs.que)) w.pbjs.que = [];

  w.pbjs.que.push(() => {
    const pbjs = w.pbjs;
    if (!pbjs || typeof pbjs.onEvent !== "function") return;

    pbjs.onEvent("bidRequested", (o: any) => { if (isConnectad(o)) bump("evt/requested"); });

    pbjs.onEvent("bidResponse", (b: any) => {
      if (!isConnectad(b)) return;
      bump("evt/bid");
      bump(`evt/bid_cur_${safeKey(b.currency || b.originalCurrency)}`);
    });

    pbjs.onEvent("noBid", (o: any) => { if (isConnectad(o)) bump("evt/nobid"); });

    pbjs.onEvent("bidTimeout", (arr: any) => {
      try { (Array.isArray(arr) ? arr : [arr]).forEach((o: any) => { if (isConnectad(o)) bump("evt/timeout"); }); } catch { /* no-op */ }
    });

    pbjs.onEvent("bidderError", (e: any) => {
      const br = e && (e.bidderRequest || e);
      if (isConnectad(br) || isConnectad(e)) bump("evt/error");
    });

    pbjs.onEvent("bidRejected", (b: any) => {
      if (!isConnectad(b)) return;
      bump("evt/rejected");
      bump(`evt/rejected_${safeKey(b.rejectionReason || b.statusMessage)}`);
    });

    pbjs.onEvent("auctionEnd", () => {
      try {
        const t = typeof pbjs.getAdserverTargeting === "function" ? pbjs.getAdserverTargeting() : {};
        Object.keys(t || {}).forEach((code) => {
          const keys = t[code] || {};
          bump(Object.prototype.hasOwnProperty.call(keys, "hb_pb_connectad") ? "hb/present" : "hb/absent");
        });
      } catch { /* no-op */ }
    });
  });
}
